import { render, staticRenderFns } from "./AnimationButton.vue?vue&type=template&id=23b28835&scoped=true&"
import script from "./AnimationButton.vue?vue&type=script&lang=js&"
export * from "./AnimationButton.vue?vue&type=script&lang=js&"
import style0 from "./AnimationButton.vue?vue&type=style&index=0&id=23b28835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b28835",
  null
  
)

export default component.exports